export default "__VITE_ASSET__CfVro5Lc__"